import { FlexLayout } from '../../components/layout/Flex';
import { Cover, Header } from '../../components/Text';
import Scroll from '../../components/Scroll';

const Intro = () => {
	return (
		<FlexLayout
			style={{
				gap: '15vh',
			}}
			direction="column"
			align="center"
		>
			<Header>22"</Header>
			<Cover>! Just A Developer</Cover>
			<Scroll />
		</FlexLayout>
	);
};

export default Intro;
